import { useState } from 'react';
import translations from '../i18n/translations';

const API = process.env.REACT_APP_API_URL || '/api';

export default function ResetPasswordPage({ token, onBack }) {
  const [uiLang] = useState('cs');
  const t = (key) => {
    const keys = key.split('.');
    let val = translations[uiLang];
    for (const k of keys) val = val?.[k];
    return val ?? key;
  };

  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [status, setStatus] = useState(''); // 'loading' | 'success' | 'error'
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (password.length < 6) return setError('Heslo musí mít alespoň 6 znaků.');
    if (password !== password2) return setError('Hesla se neshodují.');
    setStatus('loading'); setError('');
    try {
      const res = await fetch(`${API}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Chyba');
      setStatus('success');
    } catch (e) {
      setError(e.message === 'Invalid or expired token' ? 'Odkaz je neplatný nebo vypršel.' : e.message);
      setStatus('');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Outfit','Segoe UI',sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 32px rgba(0,0,0,0.10)', width: '100%', maxWidth: 420, overflow: 'hidden' }}>
        <div style={{ background: 'linear-gradient(135deg, #0e76bc 0%, #0b5e96 100%)', padding: '32px 32px 28px', textAlign: 'center' }}>
          <h1 style={{ color: '#fff', margin: 0, fontSize: 22, fontWeight: 700 }}>Nové heslo</h1>
          <p style={{ color: 'rgba(255,255,255,0.8)', margin: '6px 0 0', fontSize: 14 }}>Grandstream Partner Portal</p>
        </div>
        <div style={{ padding: '32px' }}>
          {status === 'success' ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <h2 style={{ fontSize: 18, fontWeight: 700, color: '#111827', marginBottom: 8 }}>Heslo bylo změněno</h2>
              <p style={{ color: '#6b7280', marginBottom: 24 }}>Nyní se můžete přihlásit novým heslem.</p>
              <button onClick={onBack} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                Přihlásit se
              </button>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: 18 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Nové heslo</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                  style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 15, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
                  onFocus={e => e.target.style.borderColor = '#0e76bc'}
                  onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Heslo znovu</label>
                <input type="password" value={password2} onChange={e => setPassword2(e.target.value)}
                  style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 15, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
                  onFocus={e => e.target.style.borderColor = '#0e76bc'}
                  onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
              </div>
              {error && (
                <div style={{ background: '#e8f4fc', border: '1px solid #b3d9f2', color: '#dc2626', borderRadius: 8, padding: '10px 14px', fontSize: 14, marginBottom: 18 }}>
                  {error}
                </div>
              )}
              <button onClick={handleSubmit} disabled={status === 'loading'}
                style={{ width: '100%', padding: '12px', background: status === 'loading' ? '#9ca3af' : 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: status === 'loading' ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
                {status === 'loading' ? '...' : 'Nastavit heslo'}
              </button>
              <p style={{ textAlign: 'center', marginTop: 16 }}>
                <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#0e76bc', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}>
                  ← Zpět na přihlášení
                </button>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
